import React from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgress, Input, InputAdornment, MenuItem, Select,
} from '@mui/material';

export const valuePropType = PropTypes
  .oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

function Multiselector({
  onChange, disabled, readOnly, value, loading, values, className, margin,
}) {
  return (
    <Select
      multiple
      value={value}
      onChange={(e) => onChange(e, e.target.value)}
      readOnly={readOnly}
      disabled={disabled}
      className={className}
      variant="standard"
      fullWidth
      margin={margin}
      input={(
        <Input
          endAdornment={(
            <InputAdornment position="end" sx={{ mr: 3 }}>
              {loading && (
              <CircularProgress size={20} />
              )}
            </InputAdornment>
          )}
        />
      )}
    >
      {values.map((v) => (
        <MenuItem
          key={v.value}
          value={v.value}
          disabled={v.disabled}
          sx={{ ml: (v.level || 0) }}

        >
          {v.display_name}
        </MenuItem>
      ))}
    </Select>
  );
}

Multiselector.propTypes = {
  // eslint-disable-next-line
  value: PropTypes.arrayOf(valuePropType),
  // eslint-disable-next-line
  values: PropTypes.arrayOf(PropTypes.shape({
    value: valuePropType,
    disabled: PropTypes.bool,
    display_name: PropTypes.string,
    level: PropTypes.number,
    icon: PropTypes.symbol,
  })),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  // eslint-disable-next-line
  maybeNull: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

Multiselector.defaultProps = {
  value: [],
  values: [],
  onChange: () => null,
  disabled: false,
  readOnly: false,
  maybeNull: false,
  loading: false,
  className: null,
  margin: 'dense',
};

export default Multiselector;
